import { AMAZON_URL } from "@/config";

const Footer = () => (
  <footer className="border-t border-white/10 py-12" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
      <div className="flex items-baseline gap-3">
        <span className="font-serif-display text-lg text-white">High Somatic Mastery</span>
        <span className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[#00FF8F]">Zero Cortisol</span>
      </div>
      <a
        href={AMAZON_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs uppercase tracking-[0.2em] text-[#A6A6AD] hover:text-[#00FF8F] transition-colors duration-300"
        data-testid="footer-amazon-link"
      >
        Available on Amazon
      </a>
      <p className="text-xs text-[#6E6E76]">© 2026 Joe Fenix. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
